<template>
    <footer class="site__footer">            
  <div class="site-footer">                
    <div class="decor site-footer__decor decor--type--bottom">                    
      <div class="decor__body">                        
        <div class="decor__start">
        </div>                        
        <div class="decor__end">
        </div>                        
        <div class="decor__center">
        </div>                    
      </div>                
    </div>                
    <div class="site-footer__widgets">                    
      <div class="container">                        
        <div class="row">                            
          <div class="col-12 col-xl-4">                                
            <div class="site-footer__widget footer-contacts">
              <div v-html="logo_content"></div>
              <address class="footer-contacts__contacts" v-html="phone_content">
                
              </address>                                
            </div>                            
          </div>                            
          <div class="col-6 col-md-3 col-xl-2">
            <div v-html="info_content">

            </div>
          </div>                            
          <div class="col-6 col-md-3 col-xl-2" >                                
            <div class="site-footer__widget footer-links" v-html="acct_content">
            </div>
          </div>                            
          <div class="col-12 col-md-6 col-xl-4">                                
            <div class="site-footer__widget footer-newsletter">
              <div v-html="news_content">
              </div>
              <div v-html="socialm_content">
              </div>
              <span class="app-version">Version: {{$store.getters.appVersion}}</span>

            </div>                            
          </div>                        
        </div>                    
      </div>                
    </div>            
  </div>        
</footer>
</template>

<style scoped>
  .app-version{
    font-size: 12px;
  }
</style>
<script>
import axiosvl from "../../axios/axios-vl.js";

export default {
  data() {
    return {
      logo_content: '',
      phone_content: '',
      loc_content:  '',
      info_content:  '',
      acct_content:  '',

      news_content:  '',
      socialm_content:  '',
    }
  },
  
  methods: {
    fetchCol1Logo() {
      this.isloading = true;
      this.logo_content = "";
      this.servermessages = [];

      const about_uri = this.$store.getters['api/about_uri'];

      axiosvl.post(about_uri,
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                LW3SFID: {
                  value: this.$store.getters.storefront,
                },
                LW3PAGSDC: {
                  value: "FOOTER",
                },
                LW3PAGLSD: {
                  value: "FOOTERCOL1_LOGO",
                },
              },
            },
          }
        )
        .then((response) => {
          this.isloading = false;

          const fields = response.data.webroutine.fields;
          this.logo_content = fields.LW3CNTSTR.value;

          const messages = [];
          const wrmessages = response.data.webroutine.messages;

          if (wrmessages != undefined) {
              for (var i = 0; i < wrmessages.length; i++) {
                  messages.push(wrmessages[i]);
              }
              this.servermessages = messages;
          }
        })
        .catch((error) => {
          this.isloading = false;
          this.servermessages.push(
            "Something went wrong. Please try again later."
          );
          console.log("error - " + error);
        });
    },

    fetchCol1() {
      this.isloading = true;
      this.phone_content = "";
      this.servermessages = [];

      const about_uri = this.$store.getters['api/about_uri'];

      axiosvl.post(about_uri,
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                LW3SFID: {
                  value: this.$store.getters.storefront,
                },
                LW3PAGSDC: {
                  value: "FOOTER",
                },
                LW3PAGLSD: {
                  value: "FOOTERCOL1",
                },
              },
            },
          }
        )
        .then((response) => {
          this.isloading = false;

          const fields = response.data.webroutine.fields;
          this.phone_content = fields.LW3CNTSTR.value;

          const messages = [];
          const wrmessages = response.data.webroutine.messages;

          if (wrmessages != undefined) {
              for (var i = 0; i < wrmessages.length; i++) {
                  messages.push(wrmessages[i]);
              }
              this.servermessages = messages;
          }
        })
        .catch((error) => {
          this.isloading = false;
          this.servermessages.push(
            "Something went wrong. Please try again later."
          );
          console.log("error - " + error);
        });
    },

    fetchCol2Info() {
      this.isloading = true;
      this.info_content = "";
      this.servermessages = [];

      const about_uri = this.$store.getters['api/about_uri'];

      axiosvl.post(about_uri,
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                LW3SFID: {
                  value: this.$store.getters.storefront,
                },
                LW3PAGSDC: {
                  value: "FOOTER",
                },
                LW3PAGLSD: {
                  value: "FOOTERCOL2_INFO",
                },
              },
            },
          }
        )
        .then((response) => {
          this.isloading = false;

          const fields = response.data.webroutine.fields;
          this.info_content = fields.LW3CNTSTR.value;

          const messages = [];
          const wrmessages = response.data.webroutine.messages;

          if (wrmessages != undefined) {
              for (var i = 0; i < wrmessages.length; i++) {
                  messages.push(wrmessages[i]);
              }
              this.servermessages = messages;
          }
        })
        .catch((error) => {
          this.isloading = false;
          this.servermessages.push(
            "Something went wrong. Please try again later."
          );
          console.log("error - " + error);
        });
    },

    fetchCol2Acct() {
      this.isloading = true;
      this.acct_content = "";
      this.servermessages = [];

      const about_uri = this.$store.getters['api/about_uri'];

      axiosvl.post(about_uri,
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                LW3SFID: {
                  value: this.$store.getters.storefront,
                },
                LW3PAGSDC: {
                  value: "FOOTER",
                },
                LW3PAGLSD: {
                  value: "FOOTERCOL2_ACCT",
                },
              },
            },
          }
        )
        .then((response) => {
          this.isloading = false;

          const fields = response.data.webroutine.fields;
          this.acct_content = fields.LW3CNTSTR.value;

          const messages = [];
          const wrmessages = response.data.webroutine.messages;

          if (wrmessages != undefined) {
              for (var i = 0; i < wrmessages.length; i++) {
                  messages.push(wrmessages[i]);
              }
              this.servermessages = messages;
          }
        })
        .catch((error) => {
          this.isloading = false;
          this.servermessages.push(
            "Something went wrong. Please try again later."
          );
          console.log("error - " + error);
        });
    },

    fetchCol3News() {
      this.isloading = true;
      this.news_content = "";
      this.servermessages = [];

      const about_uri = this.$store.getters['api/about_uri'];

      axiosvl.post(about_uri,
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                LW3SFID: {
                  value: this.$store.getters.storefront,
                },
                LW3PAGSDC: {
                  value: "FOOTER",
                },
                LW3PAGLSD: {
                  value: "FOOTERCOL3_NEWS",
                },
              },
            },
          }
        )
        .then((response) => {
          this.isloading = false;

          const fields = response.data.webroutine.fields;
          this.news_content = fields.LW3CNTSTR.value;

          const messages = [];
          const wrmessages = response.data.webroutine.messages;

          if (wrmessages != undefined) {
              for (var i = 0; i < wrmessages.length; i++) {
                  messages.push(wrmessages[i]);
              }
              this.servermessages = messages;
          }
        })
        .catch((error) => {
          this.isloading = false;
          this.servermessages.push(
            "Something went wrong. Please try again later."
          );
          console.log("error - " + error);
        });
    },

    fetchCol3SocialMedias() {
      this.isloading = true;
      this.socialm_content = "";
      this.servermessages = [];

      const about_uri = this.$store.getters['api/about_uri'];

      axiosvl.post(about_uri,
          {
            webroutine: {
              context: {
                "session-key-method": "hidden",
              },
              fields: {
                LW3SFID: {
                  value: this.$store.getters.storefront,
                },
                LW3PAGSDC: {
                  value: "FOOTER",
                },
                LW3PAGLSD: {
                  value: "FOOTERCOL3_SOC",
                },
              },
            },
          }
        )
        .then((response) => {
          this.isloading = false;

          const fields = response.data.webroutine.fields;
          this.socialm_content = fields.LW3CNTSTR.value;

          const messages = [];
          const wrmessages = response.data.webroutine.messages;

          if (wrmessages != undefined) {
              for (var i = 0; i < wrmessages.length; i++) {
                  messages.push(wrmessages[i]);
              }
              this.servermessages = messages;
          }
        })
        .catch((error) => {
          this.isloading = false;
          this.servermessages.push(
            "Something went wrong. Please try again later."
          );
          console.log("error - " + error);
        });
    },
  },

  mounted() {
    let tmout = 500;
    if (this.$store.getters.storefront == ''){
        tmout = 2000;
    }

    setTimeout(() => {
      this.fetchCol1Logo();
    
      this.fetchCol1();

      this.fetchCol2Info();

      this.fetchCol2Acct();

      this.fetchCol3News();

      this.fetchCol3SocialMedias();
        
    }, tmout);
    
  }
  
}
</script>